import styled from "styled-components";

export const StyledGridControls = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.containerBackground1};
  border-bottom: 1px solid #222;
  border-left: 1px solid #222;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  min-height: 110px;
  justify-content: space-between;
  padding: 0 50px;
  position: relative;
`;

export const CloseIconContainer = styled.div`
  align-items: center;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 50px;
  width: 50px;
`;

export const ButtonContainer = styled.div`
  width: 200px;
`;

export const PatternHeader = styled.h1`
  color: white;
  margin: 10px 0 0;
`;

export const Spacer = styled.div`
  width: 200px;
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Text = styled.p`
  color: white;
`;
